var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"building-block"},[_c('div',{staticClass:"building-info"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s((_vm.building && _vm.building.title) || ""))]),_c('span',{staticClass:"address"},[_vm._v(_vm._s((_vm.building && _vm.building.address) || ""))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }